export default __webpack_public_path__ + "static/media/em_tshirt_3.26a8f2c3.webp";